import React from 'react'
import {
	useMyPlayerIsFillIn,
	useMyPlayerIsMale,
    useMyPlayerName,
} from './data'
import {FaArrowRightLong} from 'react-icons/fa6'
import {IsFillin, IsMale} from './Players'

type PlayerNameProps = {
	subPlayerId?: PlayerId | null
	plain?: boolean
} & ({
	playerId?: PlayerId | null
	allowBlank: true
} | {
	playerId: PlayerId
	allowBlank?: false
})

/*
 | {
	roster: RosterData
	subs: Subs,
	i: number
}
*/

const PlayerName = (props: PlayerNameProps) => {

    const { playerId } = props

    let playerName = useMyPlayerName(playerId || '')
	const isFillin = useMyPlayerIsFillIn(playerId || '')
	const isMale = useMyPlayerIsMale(playerId || '')

    if (!playerName) {
        if (props.allowBlank) {
            playerName = ''
        } else if (playerId) {
            playerName = playerId
        } else {
            playerName = '???'
        }
    }

	if (props.plain) {
		return (
			<>
				{playerName}
			</>
		)
	}

    const myClasses = [ 'player-name' ]

    if (playerName.length >= 14) {
        myClasses.push('very-long-name')
    } else if (playerName.length >= 9) {
        myClasses.push('long-name')
    }

	let content = (
		<div className={myClasses.join(' ')}>
			{playerName}
			<IsMale value={isMale} />
			<IsFillin value={isFillin} />
		</div>
	)

	if (props.subPlayerId) {
		content = (
			<>
				<span className="player-name-transition-start">
					{content}
					<FaArrowRightLong className="icon-sub" />
				</span>
				<PlayerName playerId={props.subPlayerId} />
			</>
		)
	}

	return content
}

export default PlayerName
